// Generated by Ignite ignite.com/cli

import { SigningStargateClient, DeliverTxResponse, StdFee } from "@cosmjs/stargate";
import { EncodeObject, GeneratedType, OfflineSigner, Registry } from "@cosmjs/proto-signing";
import { msgTypes } from './registry';
import { IgniteClient } from "../client"
import { MissingWalletError } from "../helpers"
import { Api } from "./rest";
import { MsgGrantAllowance } from "./types/cosmos/feegrant/v1beta1/tx";
import { MsgRevokeAllowance } from "./types/cosmos/feegrant/v1beta1/tx";
import { MsgPruneAllowances } from "./types/cosmos/feegrant/v1beta1/tx";

import { BasicAllowance as typeBasicAllowance} from "./types"
import { PeriodicAllowance as typePeriodicAllowance} from "./types"
import { AllowedMsgAllowance as typeAllowedMsgAllowance} from "./types"
import { Grant as typeGrant} from "./types"

export { MsgGrantAllowance, MsgRevokeAllowance, MsgPruneAllowances };

type sendMsgGrantAllowanceParams = {
  value: MsgGrantAllowance,
  fee?: StdFee,
  memo?: string
};

type sendMsgRevokeAllowanceParams = {
  value: MsgRevokeAllowance,
  fee?: StdFee,
  memo?: string
};

type sendMsgPruneAllowancesParams = {
  value: MsgPruneAllowances,
  fee?: StdFee,
  memo?: string
};


type msgGrantAllowanceParams = {
  value: MsgGrantAllowance,
};

type msgRevokeAllowanceParams = {
  value: MsgRevokeAllowance,
};

type msgPruneAllowancesParams = {
  value: MsgPruneAllowances,
};


export const registry = new Registry(msgTypes);

type Field = {
	name: string;
	type: unknown;
}
function getStructure(template) {
	const structure: {fields: Field[]} = { fields: [] }
	for (let [key, value] of Object.entries(template)) {
		let field = { name: key, type: typeof value }
		structure.fields.push(field)
	}
	return structure
}
const defaultFee = {
  amount: [],
  gas: "200000",
};

interface TxClientOptions {
  addr: string
	prefix: string
	signer?: OfflineSigner
}

export const txClient = ({ signer, prefix, addr }: TxClientOptions = { addr: "http://localhost:26657", prefix: "cosmos" }) => {

  return {
		
		async sendMsgGrantAllowance({ value, fee, memo }: sendMsgGrantAllowanceParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgGrantAllowance: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgGrantAllowance({ value: MsgGrantAllowance.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgGrantAllowance: Could not broadcast Tx: '+ e.message)
			}
		},
		
		async sendMsgRevokeAllowance({ value, fee, memo }: sendMsgRevokeAllowanceParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgRevokeAllowance: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgRevokeAllowance({ value: MsgRevokeAllowance.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgRevokeAllowance: Could not broadcast Tx: '+ e.message)
			}
		},
		
		async sendMsgPruneAllowances({ value, fee, memo }: sendMsgPruneAllowancesParams): Promise<DeliverTxResponse> {
			if (!signer) {
					throw new Error('TxClient:sendMsgPruneAllowances: Unable to sign Tx. Signer is not present.')
			}
			try {			
				const { address } = (await signer.getAccounts())[0]; 
				const signingClient = await SigningStargateClient.connectWithSigner(addr,signer,{registry});
				let msg = this.msgPruneAllowances({ value: MsgPruneAllowances.fromPartial(value) })
				return await signingClient.signAndBroadcast(address, [msg], fee ? fee : defaultFee, memo)
			} catch (e: any) {
				throw new Error('TxClient:sendMsgPruneAllowances: Could not broadcast Tx: '+ e.message)
			}
		},
		
		
		msgGrantAllowance({ value }: msgGrantAllowanceParams): EncodeObject {
			try {
				return { typeUrl: "/cosmos.feegrant.v1beta1.MsgGrantAllowance", value: MsgGrantAllowance.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgGrantAllowance: Could not create message: ' + e.message)
			}
		},
		
		msgRevokeAllowance({ value }: msgRevokeAllowanceParams): EncodeObject {
			try {
				return { typeUrl: "/cosmos.feegrant.v1beta1.MsgRevokeAllowance", value: MsgRevokeAllowance.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgRevokeAllowance: Could not create message: ' + e.message)
			}
		},
		
		msgPruneAllowances({ value }: msgPruneAllowancesParams): EncodeObject {
			try {
				return { typeUrl: "/cosmos.feegrant.v1beta1.MsgPruneAllowances", value: MsgPruneAllowances.fromPartial( value ) }  
			} catch (e: any) {
				throw new Error('TxClient:MsgPruneAllowances: Could not create message: ' + e.message)
			}
		},
		
	}
};

interface QueryClientOptions {
  addr: string
}

export const queryClient = ({ addr: addr }: QueryClientOptions = { addr: "http://localhost:1317" }) => {
  return new Api({ baseURL: addr });
};

class SDKModule {
	public query: ReturnType<typeof queryClient>;
	public tx: ReturnType<typeof txClient>;
	public structure: Record<string,unknown>;
	public registry: Array<[string, GeneratedType]> = [];

	constructor(client: IgniteClient) {		
	
		this.query = queryClient({ addr: client.env.apiURL });		
		this.updateTX(client);
		this.structure =  {
						BasicAllowance: getStructure(typeBasicAllowance.fromPartial({})),
						PeriodicAllowance: getStructure(typePeriodicAllowance.fromPartial({})),
						AllowedMsgAllowance: getStructure(typeAllowedMsgAllowance.fromPartial({})),
						Grant: getStructure(typeGrant.fromPartial({})),
						
		};
		client.on('signer-changed',(signer) => {			
		 this.updateTX(client);
		})
	}
	updateTX(client: IgniteClient) {
    const methods = txClient({
        signer: client.signer,
        addr: client.env.rpcURL,
        prefix: client.env.prefix ?? "cosmos",
    })
	
    this.tx = methods;
    for (let m in methods) {
        this.tx[m] = methods[m].bind(this.tx);
    }
	}
};

const IgntModule = (test: IgniteClient) => {
	return {
		module: {
			CosmosFeegrantV_1Beta_1: new SDKModule(test)
		},
		registry: msgTypes
  }
}
export default IgntModule;